import React from "react";
import "./CustomCheckbox.scss";

interface CustomCheckboxProps {
  checked: boolean;
  onChange: () => void;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
}) => {
  return (
    <div
      className={`custom-checkbox-container ${checked ? "checked" : ""}`}
      onClick={onChange}
    >
      {/* No content, just a div that changes background color */}
    </div>
  );
};

export default CustomCheckbox;
